/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const updatePasswordRequestUserPasswordMin = 12;

export const UpdatePasswordRequest = zod
	.object({
		current_password: zod.string().describe('Current password'),
		user: zod.object({
			password: zod
				.string()
				.min(updatePasswordRequestUserPasswordMin)
				.optional()
				.describe('New password'),
			password_confirmation: zod.string().optional().describe('Password confirmation')
		})
	})
	.describe('Update password request body');

export type UpdatePasswordRequest = zod.input<typeof UpdatePasswordRequest>;
export type UpdatePasswordRequestOutput = zod.output<typeof UpdatePasswordRequest>;
